import { partition } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';

import Badge from '../../../common/components/Badge';
import { slugify } from '../../../common/utils';
import { selectNavMenuCategory } from '../../../ui/UiSelectors';
import { OtherCategoryTypes } from '../../../ui/UiTypes';
import { aiFeatureSelector } from '../../Search/selectors/searchSelectors';
import { CreativeToolsMenuOptions } from '../constants';

const CreativeToolsMenu = () => {
  const { categories } = useSelector(
    selectNavMenuCategory(OtherCategoryTypes.CREATIVE_TOOLS)
  );

  const [categoriesWithNewFeatures, filteredCategories] = partition(
    Object.keys(categories),
    (categoryName) => categories[categoryName]?.newFeature
  );

  const categoryNames = [
    ...categoriesWithNewFeatures.sort(),
    ...filteredCategories.sort(),
  ];

  const aiToolkit = useSelector(aiFeatureSelector('toolkit'));

  return (
    <>
      {categoryNames.map((opt) => {
        let category = { ...categories[opt], show: true };
        if (opt === 'ai-toolkit') {
          if (!aiToolkit.show || !aiToolkit.url) {
            return null;
          }
          category = { ...category, ...aiToolkit };
        }
        const menuOption = CreativeToolsMenuOptions[opt];

        if (!category || !menuOption) {
          return null;
        }

        const IconComponent = menuOption.icon;

        return (
          <>
            <div
              role="button"
              tabIndex={0}
              className="CreativeTools-option creativeToolsLabel w-72 px-6 py-2 flex flex-col justify-center hover:bg-gray-100"
              key={category.title}
              data-cy={slugify(category.title)}
              onClick={(evt) =>
                (evt.currentTarget.firstChild as HTMLLinkElement).click()
              }
              onKeyDown={(evt) => {
                if (evt.key === 'Enter' || evt.key === ' ') {
                  evt.preventDefault();
                  (evt.currentTarget.firstChild as HTMLLinkElement).click();
                }
              }}
            >
              <a
                className="border-solid border-0 border-current flex items-center gap-4 text-gray-900 font-normal no-underline"
                href={category?.url}
              >
                <div className="w-6 h-6 p-1.5 box-content flex-none shadow-popover bg-white rounded-lg">
                  {menuOption.icon && <IconComponent id={`icon-${opt}`} />}
                </div>
                <div className="flex flex-col">
                  <div className="flex items-center">
                    <div className="font-semibold text-sm">
                      {category.title}
                    </div>
                    {category?.newFeature && (
                      <Badge
                        badgeText="New"
                        className="mx-2 bg-gradient-to-r from-purple-600 to-pink-400"
                      />
                    )}
                    {category?.isBeta && (
                      <Badge badgeText="Beta" className="mx-2" />
                    )}
                  </div>
                  <div className="font-inter font-normal text-sm text-gray-700 leading-normal tracking-normal">
                    {menuOption?.description}
                  </div>
                </div>
              </a>
            </div>
            <hr className="divider mx-6" />
          </>
        );
      })}
    </>
  );
};

export default CreativeToolsMenu;
